import React from 'react';
import PropTypes from 'prop-types';

import StatsCard from './StatsCard';

import './ClaimsStatsOverview.scss';

function ClaimsStatsOverview(props) {
  const { claimsStats = {} } = props;
  const { openCount, actionRequiredCount, acceptedAndAwaitingPaymentCount, draftCount } = claimsStats;

  return (
    <div styleName="container">
      <StatsCard value={openCount}>Total open</StatsCard>
      <StatsCard value={draftCount} intent="warning">
        Draft Claims
      </StatsCard>
      <StatsCard value={actionRequiredCount} intent="warning">
        Action required
      </StatsCard>
      <StatsCard value={acceptedAndAwaitingPaymentCount} intent="positive" isLast>
        Accepted & awaiting payment
      </StatsCard>
    </div>
  );
}

ClaimsStatsOverview.propTypes = {
  claimsStats: PropTypes.object,
};

export default ClaimsStatsOverview;
